// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"b9ba6867","274":"1eb441af","372":"53bd5c2d","640":"525b602d"}[chunkId] + ".chunk.js";
};